import "../../layerslider.css";
import { useEffect, useRef, useState } from "react";
import { ButtonGroup } from "@/types/layerslider";
import { getEasing, getTransform } from "@/main/_components/utils/slider-animations";
interface SliderButtonProps {
  group: ButtonGroup;
  lang: string;
}

const SliderButton: React.FC<SliderButtonProps> = ({ group, lang }) => {
  const [isInView, setIsInView] = useState<boolean>(false);
  const buttonRef = useRef<HTMLAnchorElement | null>(null);
  useEffect(() => {
    const button = buttonRef.current;
    if (!button) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.1 },
    );

    observer.observe(button);

    return () => {
      observer.unobserve(button);
    };
  }, []);

  const easingIn = getEasing(group.easingin);
  const easingOut = getEasing(group.easingout);
  const transitionInTransform = getTransform(group.transitionin, easingIn);
  const transitionOutTransform = getTransform(group.transitionout, easingOut);

  const [windowWidth, setWindowWidth] = useState<number | null>(null);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    setWindowWidth(window.innerWidth); // initialize once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const baseWidth = 1200;
  const scaleFactor = windowWidth !== null && windowWidth < baseWidth ? windowWidth / baseWidth : 1;

  const responsiveLeft = `${parseFloat(group.left[lang]) * scaleFactor}px`;
  const responsiveTop = `${parseFloat(group.top[lang]) * scaleFactor}px`;

  return (
    <a
      ref={buttonRef}
      href={group.button_href}
      target={group.button_target === "1" ? "_blank" : "_self"}
      rel="noopener noreferrer"
      className={`absolute ${group.button_class}`}
      style={{
        height: "auto",
        left: responsiveLeft,
        top: responsiveTop,
        zIndex: group.p_index,
        order: group.sort_order,
        opacity: isInView ? 1 : 0,
        transform: isInView ? transitionInTransform : transitionOutTransform,
        transition: `all ${isInView ? group.durationin : group.durationout}ms ${isInView ? easingIn : easingOut}`,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      {group.description[lang]}
    </a>
  );
};

export default SliderButton;
